import "core-js/modules/es.array.push.js";
import config from "@Web3WalletConfig/config.json";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "mLaunch",
  props: {
    tokenAddress: null
  },
  data() {
    return {
      ethFee: 0,
      error: null,
      loading: false,
      // tokenAddress: "0x0EBE68eC7465Ff99A595c1462d90b55275636969", // 用于 changeLeader 的 token 地址
      // tokenAddress: "0x1428A62Ed2D8405dF4968baF1966873a67D36969", //已到外盘
      leaderBoxShow: false,
      feeBoxShow: false,
      leaderFee: 0,
      tokenData: null,
      leaderAddress: null,
      // changeLeaderResult: null,

      isCollectLoading: false,
      isTwitterClaimLoading: false,
      isTwitterAuthorizeLoading: false,
      poolLaunchTimer: null
    };
  },
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isWallet"]),
    ...userVuex.mapState(["web3Data", "userInfo"]),
    isPoolLaunch() {
      return this.feeBoxShow || this.leaderBoxShow;
    }
  },
  watch: {
    isWallet: {
      async handler(newBool, oldBool) {
        console.log(1010101001);
        this.walletWeb3Init();
      },
      deep: true,
      immediate: true
    },
    isPoolLaunch: {
      handler(newBool, oldBool) {
        if (newBool) {
          this.poolLaunchFnc();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...userVuex.mapActions(["launchToken", "upLoadImg", "getTokenInfo"]),
    ...walletVuex.mapActions(["doConnect"]),
    ...userVuex.mapMutations(["setWeb3Data"]),
    async walletWeb3Init() {
      // 在 mounted 中初始化 web3Wallet
      try {
        // 确保 RPC 配置已加载
        if (!this.$store.state.user.rpc) {
          await this.$store.dispatch("user/getChainInfo");
        }

        // 初始化 web3Wallet
        await this.web3Wallet.connectJsonRpc();

        //计算待领取费用
        await this.callCollectFee();

        //显示是否有待领取的leader费用需要认证认领
        await this.callLeader();
        console.log("web3Wallet 初始化完成");
      } catch (err) {
        console.error("web3Wallet 初始化失败:", err);
        // this.error = "web3Wallet 初始化失败: " + err.message;
        this.$toasted.error("web3Wallet initialization failed: " + err.message);
      }
    },
    async poolLaunchFnc() {
      const fnc = async () => {
        try {
          if (this.leaderBoxShow) {
            let leaderFee = await this.web3Wallet.contract("lplocker", "lpLocker").call("leaderFee", [this.tokenAddress]);
            this.leaderFee = (Number(leaderFee) / 10 ** 18).toFixed(5);
          }
          if (this.feeBoxShow && this.web3Wallet.address) {
            const amount = await this.web3Wallet.contract("lplocker", "lpLocker").call("collect", [this.tokenAddress, this.web3Wallet.address]);
            this.ethFee = (Number(amount.toString()) / 10 ** 18).toFixed(5);
          }
          console.log("pool ethFee leaderFee: ", this.feeBoxShow, this.leaderBoxShow, this.leaderFee, this.ethFee);
          this.poolLaunchFnc();
        } catch (err) {
          clearTimeout(this.poolLaunchTimer);
        }
      };
      this.poolLaunchTimer = setTimeout(fnc, 6000);
    },
    async refreshFees() {
      if (!this.tokenAddress) return;
      const tasks = [this.callLeader()];
      if (this.web3Wallet.address) tasks.push(this.callCollectFee());
      await Promise.all(tasks);
    },
    async callLeader() {
      //先调用查询该代币的创建者和发布者
      console.log("this.tokenAddressthis.tokenAddressthis.tokenAddressthis.tokenAddressthis.tokenAddress111", this.tokenAddress);
      const tokenInfo = await this.web3Wallet.contract("marspump", "marsPumpAddr").call("tokenInfo", [this.tokenAddress]);
      console.log("tokenInfo", tokenInfo);
      this.leaderAddress = tokenInfo.leader;
      let leaderFee = await this.web3Wallet.contract("lplocker", "lpLocker").call("leaderFee", [this.tokenAddress]);
      console.log("leaderFee", leaderFee);
      this.leaderFee = (Number(leaderFee) / 10 ** 18).toFixed(5);
      if (tokenInfo.leader === this.web3Wallet.address && leaderFee > 0 || tokenInfo.leader === "0x0000000000000000000000000000000000000000") {
        this.leaderBoxShow = true;
      } else {
        this.leaderBoxShow = false;
      }
      this.tokenData = await this.getTokenInfo({
        token: this.tokenAddress
      });
      console.log("this.tokenData", this.tokenData);
    },
    async collectFee() {
      if (this.isCollectLoading) return;
      this.isCollectLoading = true;
      const res = await this.web3Wallet.contract("lplocker", "lpLocker").send("collect", [this.tokenAddress, this.web3Wallet.address]);
      if (!res) {
        this.isCollectLoading = false;
        return;
      }
      console.log("resresresresresres", res);
      this.$toasted.success("Collect success!");
      this.isCollectLoading = false;
      await this.callCollectFee();
    },
    async callCollectFee() {
      return new Promise(async resolve => {
        try {
          // this.error = null;
          this.ethFee = null;
          this.loading = true;

          // 确保 web3Wallet 已初始化
          // if (!this.web3Wallet || !this.web3Wallet.web3) {
          //   console.log("web3Wallet 未初始化，正在初始化...");
          //   await this.web3Wallet.connectJsonRpc();
          //   resolve();
          // }

          //先调用查询该代币的创建者和发布者
          const tokenInfo = await this.web3Wallet.contract("marspump", "marsPumpAddr").call("tokenInfo", [this.tokenAddress]);
          console.log("tokenInfo", tokenInfo);
          console.log("开始调用 collectFee，token 地址:", this.tokenAddress);
          if (!this.web3Wallet.address) {
            this.loading = false;
            resolve();
            return;
          }
          console.log(3333333333);
          const amount = await this.web3Wallet.contract("lplocker", "lpLocker").call("collect", [this.tokenAddress, this.web3Wallet.address]);
          console.log("collectFee 调用成功:", amount, this.web3Wallet.address, tokenInfo.leader, tokenInfo.creator);
          if (this.web3Wallet.address === tokenInfo.leader) {
            this.feeBoxShow = true;
            console.log("当前身份是leader");
            this.ethFee = (Number(amount.toString()) / 10 ** 18).toFixed(5);
          } else if (this.web3Wallet.address === tokenInfo.creator) {
            this.feeBoxShow = true;
            console.log("当前身份是creator");
            this.ethFee = (Number(amount.toString()) / 10 ** 18).toFixed(5);
          }
          resolve(this.ethFee);
          this.loading = false;
          console.log("处理后的结果:", this.ethFee);
          console.log(777777777777);
        } catch (err) {
          console.error("调用 collectFee 失败:", err);
          resolve();
          // this.error = err.message || "调用失败";
          this.$toasted.error(err.message || "Call failed");
        } finally {
          resolve();
          this.loading = false;
        }
      });
    },
    // 请求服务端获取 change_leader 签名
    async getChangeLeaderSignature(tokenAddress) {
      try {
        const params = {
          token_address: tokenAddress
        };
        console.log("请求 change_leader 签名，参数:", params);
        const res = await this.$http.post("token/change_leader", params);
        if (!res.code) {
          console.log("获取签名成功:", res.data);
          return res.data;
        } else {
          this.isTwitterClaimLoading = false;
          throw new Error(res.message || "获取签名失败");
        }
      } catch (err) {
        this.isTwitterClaimLoading = false;
        console.error("获取 change_leader 签名失败:", err);
        throw new Error("获取签名失败: " + err.message);
      }
    },
    // 调用合约的 changeLeader 方法
    async callChangeLeader() {
      if (this.isTwitterClaimLoading) return;
      this.isTwitterClaimLoading = true;
      try {
        // this.error = null;
        // this.changeLeaderResult = null;
        this.loading = true;
        console.log("开始 changeLeader 流程...");

        // 1. 请求服务端获取签名, 这里的请求只是个示例， 需要增加twitter授权功能， 再上传twiiter授权码在服务端校验
        const signature = await this.getChangeLeaderSignature(this.tokenAddress);
        console.log("获取到签名:", signature);
        if (!signature) {
          this.isTwitterClaimLoading = false;
          return;
        }

        // 2. 验证签名数据结构
        if (!signature.r || !signature.s || !signature.v || !signature.data) {
          this.isTwitterClaimLoading = false;
          throw new Error("签名数据格式错误");
        }

        // 3. 调用合约的 changeLeader 方法
        console.log("调用合约 changeLeader 方法...");
        const result = await this.web3Wallet.contract("marspump", "marsPumpAddr").send("changeLeader", [signature.data.token, signature.data.leader, signature.data.expire, signature.r, signature.s, signature.v]);
        if (!result) {
          this.isTwitterClaimLoading = false;
          return;
        }
        this.isTwitterClaimLoading = false;
        console.log("changeLeader 调用成功:", result);
        // this.changeLeaderResult = result.transactionHash || result.hash || "交易成功";
        this.$toasted.success("Transaction Success");
        await this.callLeader();
        await this.callCollectFee();
      } catch (err) {
        this.isTwitterClaimLoading = false;
        console.error("调用 changeLeader 失败:", err);
        // this.error = err.message || "调用失败";
        this.$toasted.error(err.message || "Call failed");
      } finally {
        this.loading = false;
      }
    },
    async getTwitterAuthUrl() {
      // if (this.isConnect !== "connected") {
      //   await this.doConnect();
      // }
      try {
        if (this.isTwitterAuthorizeLoading) return;
        this.isTwitterAuthorizeLoading = true;
        const signStr = "Get Twitter Auth Url";
        const signature = await this.web3Wallet.signMessage(signStr);
        if (!signature) {
          this.isTwitterAuthorizeLoading = false;
          return;
        }
        const res = await this.$http.post("auth/twitter/authurl", {
          address: this.web3Wallet.address,
          signature: signature,
          signStr: signStr,
          callback: this.web3metadata.url + "twitter/callback"
        });
        this.isTwitterAuthorizeLoading = false;
        if (res.code == 0) {
          localStorage.setItem("twitter_callback_path", location.href);
          // open(res.data.url, "target");
          window.location.href = res.data.url;
        } else {
          // this.error = res.message;
          this.$toasted.error(res.message);
        }
      } catch (err) {
        // this.error = err.message || "获取失败";
        this.$toasted.error(err.message || "Authorization failed");
      }
    }
  },
  async mounted() {},
  beforeDestroy() {
    clearTimeout(this.poolLaunchTimer);
  }
};